import React from "react";

function RefreshLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.55283 3.69426C6.06496 2.38397 7.99948 1.66396 10.0003 1.66676C14.6028 1.66676 18.3337 5.39759 18.3337 10.0001C18.3337 11.7801 17.7753 13.4301 16.8253 14.7834L14.167 10.0001H16.667C16.6671 8.69311 16.283 7.41493 15.5625 6.32447C14.8421 5.23401 13.8169 4.37939 12.6146 3.86686C11.4123 3.35433 10.0859 3.20651 8.80029 3.44177C7.51466 3.67703 6.32654 4.28501 5.38366 5.19009L4.55283 3.69426ZM15.4478 16.3059C13.9357 17.6162 12.0012 18.3362 10.0003 18.3334C5.39783 18.3334 1.66699 14.6026 1.66699 10.0001C1.66699 8.22009 2.22533 6.57009 3.17533 5.21676L5.83366 10.0001H3.33366C3.33355 11.3071 3.71762 12.5853 4.43811 13.6757C5.15859 14.7662 6.18372 15.6208 7.38601 16.1333C8.5883 16.6458 9.91473 16.7937 11.2004 16.5584C12.486 16.3231 13.6741 15.7152 14.617 14.8101L15.4478 16.3059Z"
        fill="#7950FF"
      />
    </svg>
  );
}

export default RefreshLogo;
